import { GridValidRowModel } from '@mui/x-data-grid';
import { format, isValid, parseISO } from 'date-fns';

import { wrapAndCenterHeader } from './columnStyling';

import TimestampDisplay from '../TimestampDisplay';

/** A helper to generate some params for a date MUI column. */
const addDateColumnProps = (
  /** The display name of the column header. */
  headerName: string,
  /** The width of the column. */
  width = 120,
  /** Pass a `date-fns` package string format to override the 'P' default. */
  dateFormat: 'MMMM yyyy' | 'P' | 'Ppp' = 'P',
  align: 'center' | 'left' | 'right' = 'center',
): Partial<GridValidRowModel> => ({
  type: 'date',
  headerName, // This is used as a label by the filter's component
  width,
  headerAlign: align,
  align,
  valueGetter: (value: any): Date | null => {
    if (value) {
      // Handle a string date vs a Date object
      return typeof value === 'string' ? parseISO(value) : value;
    }
    return null;
  },
  valueFormatter: (value: Date | null): string =>
    isValid(value) ? format(value, dateFormat) : '',
  renderHeader: () => wrapAndCenterHeader(headerName),
  renderCell: (params) =>
    dateFormat === 'Ppp' ? (
      <TimestampDisplay date={params.value} />
    ) : (
      params.formattedValue
    ),
});

export default addDateColumnProps;
